import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "row items-center justify-end" };
const _hoisted_2 = { class: "q-gutter-md row items-start" };
const _hoisted_3 = { class: "row items-center justify-end" };
const _hoisted_4 = {
    key: 0,
    class: "text-red items-center"
};
const _hoisted_5 = { class: "text-bold line-break" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = {
    key: 20,
    class: "text-left",
    style: { "vertical-align": "top" }
};
const _hoisted_8 = {
    key: 0,
    class: "row items-start q-gutter-sm"
};
const _hoisted_9 = {
    key: 0,
    class: "file-wrapper col rounded-borders"
};
const _hoisted_10 = {
    key: 21,
    class: "text-left",
    style: { "vertical-align": "top" }
};
const _hoisted_11 = {
    key: 0,
    class: "row items-start q-gutter-sm no-wrap"
};
const _hoisted_12 = {
    key: 0,
    class: "file-wrapper col rounded-borders"
};
const _hoisted_13 = { class: "file-name" };
const _hoisted_14 = { class: "q-px-md" };
const _hoisted_15 = { class: "q-px-md" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_td = _resolveComponent("q-td");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_date = _resolveComponent("q-date");
    const _component_q_popup_proxy = _resolveComponent("q-popup-proxy");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_select = _resolveComponent("q-select");
    const _component_q_time = _resolveComponent("q-time");
    const _component_q_tr = _resolveComponent("q-tr");
    const _component_q_file = _resolveComponent("q-file");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    const _directive_close_popup = _resolveDirective("close-popup");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (!_ctx.props.row.isDeleted)
            ? (_openBlock(), _createBlock(_component_q_tr, { key: 0 }, {
                default: _withCtx(() => [
                    (_ctx.props.columns.some(x => x.name === 'delete' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 0,
                            class: "text-left",
                            style: { "vertical-align": "top" }
                        }, {
                            default: _withCtx(() => [
                                (_ctx.isMultipleKeiyaku)
                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                        key: 0,
                                        name: "delete",
                                        color: "red",
                                        size: "2em",
                                        class: "cursor-pointer delete-icon q-pt-sm",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.remove(_ctx.props.row.taikyoNo)))
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_q_td, {
                        class: "text-left",
                        style: { "vertical-align": "top", "padding-top": "15px" }
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.props.row.bukkenName), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, {
                        class: "text-left",
                        style: { "vertical-align": "top", "padding-top": "15px" }
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.props.row.roomNumber), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, {
                        class: "text-left",
                        style: { "vertical-align": "top", "padding-top": "15px" }
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.props.row.nyukyosha), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_input, {
                                modelValue: _ctx.props.row.taikyoYmd,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.props.row.taikyoYmd) = $event)),
                                color: "positive",
                                outlined: "",
                                "bottom-slots": "",
                                dense: "",
                                error: _ctx.getValidator(_ctx.props.row)?.taikyoYmd.error,
                                "error-message": _ctx.getValidator(_ctx.props.row)?.taikyoYmd.message
                            }, {
                                append: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                        name: "event",
                                        class: "cursor-pointer"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_popup_proxy, {
                                                ref: "qDateProxy",
                                                "transition-show": "scale",
                                                "transition-hide": "scale"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_date, {
                                                        modelValue: _ctx.props.row.taikyoYmd,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.props.row.taikyoYmd) = $event)),
                                                        color: "green-7"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_1, [
                                                                _withDirectives(_createVNode(_component_q_btn, {
                                                                    label: "閉じる",
                                                                    color: "green-7",
                                                                    flat: ""
                                                                }, null, 512), [
                                                                    [_directive_close_popup]
                                                                ])
                                                            ])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }, 512)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue", "error", "error-message"])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, {
                        class: "text-left",
                        style: { "vertical-align": "top", "padding-top": "15px" }
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.props.row.kaiyakuYmd == null ? "" : _ctx.dayjs(_ctx.props.row.kaiyakuYmd ?? "").format("YYYY/MM/DD")), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_select, {
                                modelValue: _ctx.props.row.taikyoRiyuKb,
                                "onUpdate:modelValue": [
                                    _cache[3] || (_cache[3] = ($event) => ((_ctx.props.row.taikyoRiyuKb) = $event)),
                                    _cache[4] || (_cache[4] = ($event) => (_ctx.clearTaikyoRiyu(_ctx.props.row)))
                                ],
                                options: _ctx.props.taikyoForInput.taikyoReasons,
                                "option-label": 'label',
                                "option-value": 'value',
                                color: "positive",
                                outlined: "",
                                "bottom-slots": "",
                                dense: "",
                                "emit-value": "",
                                "map-options": "",
                                error: _ctx.getValidator(_ctx.props.row)?.taikyoRiyuKb.error,
                                "error-message": _ctx.getValidator(_ctx.props.row)?.taikyoRiyuKb.message
                            }, null, 8, ["modelValue", "options", "error", "error-message"])
                        ]),
                        _: 1
                    }),
                    (_ctx.props.columns.some(x => x.name === 'taikyoRiyu' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 1 }, {
                            default: _withCtx(() => [
                                (_ctx.props.row.taikyoRiyuKb === _ctx.TaikyoRiyuKb.Other || _ctx.props.row.taikyoRiyuKb === _ctx.TaikyoRiyuKb.DissatisfactionOrTrouble)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.taikyoRiyu,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.props.row.taikyoRiyu) = $event)),
                                        outlined: "",
                                        "bottom-slots": "",
                                        dense: "",
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.taikyoRiyu.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.taikyoRiyu.message
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'sonotaKeiyaku' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 2 }, {
                            default: _withCtx(() => [
                                (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb !== _ctx.KeyReturnNameKb.HandoverDate)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.sonotaKeiyaku,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.props.row.sonotaKeiyaku) = $event)),
                                        type: "textarea",
                                        rows: "1",
                                        hint: "例）屋外駐車場2区画5番",
                                        color: "positive",
                                        outlined: "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.sonotaKeiyaku.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.sonotaKeiyaku.message
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_q_td, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_select, {
                                modelValue: _ctx.props.row.renrakuKb,
                                "onUpdate:modelValue": [
                                    _cache[7] || (_cache[7] = ($event) => ((_ctx.props.row.renrakuKb) = $event)),
                                    _cache[8] || (_cache[8] = ($event) => (_ctx.clearRenrakuField(_ctx.props.row)))
                                ],
                                options: _ctx.props.taikyoForInput.contactKbList,
                                "option-label": 'label',
                                "option-value": 'value',
                                color: "positive",
                                "emit-value": "",
                                "map-options": "",
                                outlined: "",
                                "bottom-slots": "",
                                dense: "",
                                clearable: "",
                                "clear-icon": "close"
                            }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                    }),
                    (_ctx.props.columns.some(x => x.name === 'renrakuName' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 3 }, {
                            default: _withCtx(() => [
                                (_ctx.props.row.renrakuKb === _ctx.RenrakuKb.Other)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.renrakuName,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.props.row.renrakuName) = $event)),
                                        color: "positive",
                                        outlined: "",
                                        "bottom-slots": "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.renrakuName.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.renrakuName.message
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'renrakuRelationship' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 4 }, {
                            default: _withCtx(() => [
                                (_ctx.props.row.renrakuKb === _ctx.KeyReturnAdrKb.Other)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.renrakuRelationship,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.props.row.renrakuRelationship) = $event)),
                                        color: "positive",
                                        outlined: "",
                                        "bottom-slots": "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.renrakuRelationship.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.renrakuRelationship.message
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'tel' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 5 }, {
                            default: _withCtx(() => [
                                ([_ctx.RenrakuKb.Hojin, _ctx.RenrakuKb.Nyukyosha, _ctx.RenrakuKb.Other].includes(_ctx.props.row.renrakuKb ?? -1))
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.tel,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.props.row.tel) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.tel.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.tel.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'email' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 6 }, {
                            default: _withCtx(() => [
                                ([_ctx.RenrakuKb.Hojin, _ctx.RenrakuKb.Nyukyosha, _ctx.RenrakuKb.Other].includes(_ctx.props.row.renrakuKb ?? -1))
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.email,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.props.row.email) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.email.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.email.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'keyReturnYmd' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 7 }, {
                            default: _withCtx(() => [
                                (!_ctx.isMMA)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.keyReturnYmd,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.props.row.keyReturnYmd) = $event)),
                                        hint: '※ ' + _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnName + 'を入力してください。',
                                        color: "positive",
                                        outlined: "",
                                        "bottom-slots": "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.keyReturnYmd.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.keyReturnYmd.message
                                    }, {
                                        append: _withCtx(() => [
                                            _createVNode(_component_q_icon, {
                                                name: "event",
                                                class: "cursor-pointer"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_popup_proxy, {
                                                        ref: "selectDate",
                                                        "transition-show": "scale",
                                                        "transition-hide": "scale"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", null, [
                                                                _createElementVNode("div", _hoisted_2, [
                                                                    _createVNode(_component_q_date, {
                                                                        modelValue: _ctx.props.row.keyReturnStrYmd,
                                                                        "onUpdate:modelValue": [
                                                                            _cache[13] || (_cache[13] = ($event) => ((_ctx.props.row.keyReturnStrYmd) = $event)),
                                                                            _cache[14] || (_cache[14] = ($event) => (_ctx.applyDateTime(_ctx.props.row)))
                                                                        ],
                                                                        color: "green-7"
                                                                    }, null, 8, ["modelValue"]),
                                                                    (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb !== _ctx.KeyReturnNameKb.HandoverDate)
                                                                        ? (_openBlock(), _createBlock(_component_q_time, {
                                                                            key: 0,
                                                                            modelValue: _ctx.props.row.keyReturnStrTime,
                                                                            "onUpdate:modelValue": [
                                                                                _cache[15] || (_cache[15] = ($event) => ((_ctx.props.row.keyReturnStrTime) = $event)),
                                                                                _cache[16] || (_cache[16] = ($event) => (_ctx.applyDateTime(_ctx.props.row)))
                                                                            ],
                                                                            color: "green-7",
                                                                            "minute-options": [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
                                                                            rules: ['rule']
                                                                        }, null, 8, ["modelValue"]))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_3, [
                                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                                        label: "閉じる",
                                                                        color: "green-7",
                                                                        flat: ""
                                                                    }, null, 512), [
                                                                        [_directive_close_popup]
                                                                    ])
                                                                ])
                                                            ])
                                                        ]),
                                                        _: 1
                                                    }, 512)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "hint", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'precautions' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 8 }, {
                            default: _withCtx(() => [
                                (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.PreferredAttendanceDatetime)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.desiredDateMessage), 1),
                                        _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.desiredDateEntryMessage), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'numberOfReturnKeys' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 9 }, {
                            default: _withCtx(() => [
                                (!_ctx.isMMA && [_ctx.KeyReturnNameKb.PreferredAttendanceDatetime, _ctx.KeyReturnNameKb.KeyReturnScheduledDatetime].includes(_ctx.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb ?? -1))
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.numberOfReturnKeys,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.props.row.numberOfReturnKeys) = $event)),
                                        color: "positive",
                                        type: "number",
                                        outlined: "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.numberOfReturnKeys.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.numberOfReturnKeys.message
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'shopName' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 10,
                            class: "text-left",
                            style: { "vertical-align": "top", "padding-top": "15px" }
                        }, {
                            default: _withCtx(() => [
                                (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.KeyReturnScheduledDatetime)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.props.row.shopName), 1),
                                        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "text-caption" }, "※ こちらの店舗に鍵を返却してください。", -1))
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'selectedTachiaishaKbn' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 11 }, {
                            default: _withCtx(() => [
                                (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.PreferredAttendanceDatetime)
                                    ? (_openBlock(), _createBlock(_component_q_select, {
                                        key: 0,
                                        modelValue: _ctx.props.row.taikyoTachiaiKb,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.props.row.taikyoTachiaiKb) = $event)),
                                        options: _ctx.props.taikyoForInput.tachiaishaKbnList,
                                        "option-label": 'label',
                                        "option-value": 'value',
                                        clearable: "",
                                        "clear-icon": "close",
                                        color: "positive",
                                        outlined: "",
                                        "bottom-slots": "",
                                        "emit-value": "",
                                        "map-options": "",
                                        dense: ""
                                    }, null, 8, ["modelValue", "options"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'taikyoTachiaiName' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 12 }, {
                            default: _withCtx(() => [
                                (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.PreferredAttendanceDatetime)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.taikyoTachiaiName,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.props.row.taikyoTachiaiName) = $event)),
                                        color: "positive",
                                        outlined: "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.taikyoTachiaiName.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.taikyoTachiaiName.message
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'keyReturnAdrKb' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 13 }, {
                            default: _withCtx(() => [
                                (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.KeyReturnScheduledDatetime)
                                    ? (_openBlock(), _createBlock(_component_q_select, {
                                        key: 0,
                                        modelValue: _ctx.props.row.keyReturnAdrKb,
                                        "onUpdate:modelValue": [
                                            _cache[21] || (_cache[21] = ($event) => ((_ctx.props.row.keyReturnAdrKb) = $event)),
                                            _cache[22] || (_cache[22] = ($event) => (_ctx.clearSoufuField(_ctx.props.row)))
                                        ],
                                        options: _ctx.props.taikyoForInput.contactKbList,
                                        "option-label": 'label',
                                        "option-value": 'value',
                                        color: "positive",
                                        "emit-value": "",
                                        "map-options": "",
                                        outlined: "",
                                        "bottom-slots": "",
                                        dense: "",
                                        clearable: "",
                                        "clear-icon": "close",
                                        hint: "※電子錠の方は、その他を選択し「送付不要」と入力してください。"
                                    }, null, 8, ["modelValue", "options"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'soufuName' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 14 }, {
                            default: _withCtx(() => [
                                (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.soufuName,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.props.row.soufuName) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.soufuName.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.soufuName.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'postCode' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 15 }, {
                            default: _withCtx(() => [
                                (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Hojin || _ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.postCode,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.props.row.postCode) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.postCode.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.postCode.message,
                                        dense: "",
                                        outlined: "",
                                        onBlur: _cache[25] || (_cache[25] = ($event) => (_ctx.findAddress(_ctx.props.row)))
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'adr1' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 16 }, {
                            default: _withCtx(() => [
                                (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Hojin || _ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.adr1,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.props.row.adr1) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.adr1.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.adr1.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'adr2' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 17 }, {
                            default: _withCtx(() => [
                                (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Hojin || _ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.adr2,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.props.row.adr2) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.adr2.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.adr2.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'adr3' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 18 }, {
                            default: _withCtx(() => [
                                (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Hojin || _ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.adr3,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.props.row.adr3) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.adr3.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.adr3.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'soufuSonota' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, { key: 19 }, {
                            default: _withCtx(() => [
                                (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Other)
                                    ? (_openBlock(), _createBlock(_component_q_input, {
                                        key: 0,
                                        modelValue: _ctx.props.row.soufuSonota,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_ctx.props.row.soufuSonota) = $event)),
                                        label: "送付先・連絡方法など（自由記入）",
                                        hint: "※住所を入力の際は、必ず「郵便番号」を入力してください。",
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.soufuSonota.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.soufuSonota.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'hasonFile' && x.visible === true))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                            (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.KeyReturnScheduledDatetime)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_component_q_btn, {
                                        icon: "save",
                                        color: "green-7",
                                        onClick: _cache[30] || (_cache[30] = ($event) => (_ctx.openDialogHason()))
                                    }),
                                    (_ctx.props.row.fileList.some(x => x.fileKb === 0 && x.delFlg === false))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.row.fileList.filter(x => x.fileKb === 0 && x.delFlg === false), (file) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: file.fileId,
                                                    class: "file-item"
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(file.fileName), 1),
                                                    _createVNode(_component_q_btn, {
                                                        icon: "close",
                                                        flat: "",
                                                        round: "",
                                                        dense: "",
                                                        onClick: ($event) => (_ctx.fileDelete(file, _ctx.props.row.fileList))
                                                    }, null, 8, ["onClick"])
                                                ]));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "text-caption text-grey" }, "※ 破損・汚損がある場合は、ファイルをアップロードしてください。", -1))
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'otherFile' && x.visible === true))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                            (!_ctx.isMMA)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createVNode(_component_q_btn, {
                                        icon: "save",
                                        color: "green-7",
                                        onClick: _cache[31] || (_cache[31] = ($event) => (_ctx.openDialogOther()))
                                    }),
                                    (_ctx.props.row.fileList.some(x => x.fileKb === 1 && x.delFlg === false))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.row.fileList.filter(x => x.fileKb === 1 && x.delFlg === false), (file) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: file.fileId,
                                                    class: "file-item"
                                                }, [
                                                    _createElementVNode("span", _hoisted_13, _toDisplayString(file.fileName), 1),
                                                    _createVNode(_component_q_btn, {
                                                        icon: "close",
                                                        flat: "",
                                                        round: "",
                                                        dense: "",
                                                        onClick: ($event) => (_ctx.fileDelete(file, _ctx.props.row.fileList))
                                                    }, null, 8, ["onClick"])
                                                ]));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }))
            : _createCommentVNode("", true),
        _createVNode(_component_q_dialog, {
            modelValue: _ctx.dialogOpenHason,
            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((_ctx.dialogOpenHason) = $event)),
            persistent: ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_q_card, { style: { "min-width": "40vw" } }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "q-gutter-md" }, {
                            default: _withCtx(() => [
                                _cache[45] || (_cache[45] = _createElementVNode("div", { class: "q-px-md" }, [
                                    _createElementVNode("div", {
                                        class: "text-h5",
                                        style: { "font-weight": "bold" }
                                    }, "破損汚損情報"),
                                    _createElementVNode("ul", null, [
                                        _createElementVNode("li", { class: "text-subtitle2" }, "本申告書記載の金額と賃貸借契約書の「故意過失による破損・汚損単申告書（単価表）」が相違している場合は、金額の低い方で精算を行います。"),
                                        _createElementVNode("li", { class: "text-subtitle2" }, "上記金額は、目安金額であり退去後別途見積りとなる場合があります。"),
                                        _createElementVNode("li", { class: "text-subtitle2" }, "上記に記載の無い項目については、退去後別途見積りとなります。"),
                                        _createElementVNode("li", { class: "text-subtitle2" }, "通常のクリーニングでは除去できない程度のたばこのヤニ汚れや、結露を放置したことにより拡大した壁面、床等のカビ・シミ等の汚れは借主の故意過失による汚損になります。")
                                    ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_q_file, {
                                        modelValue: _ctx.tmpFile,
                                        "onUpdate:modelValue": [
                                            _cache[32] || (_cache[32] = ($event) => ((_ctx.tmpFile) = $event)),
                                            _cache[33] || (_cache[33] = ($event) => (_ctx.onFilePicked(_ctx.tmpFile, _ctx.props.row)))
                                        ],
                                        outlined: "",
                                        dense: "",
                                        "use-chips": "",
                                        label: "ファイル選択",
                                        accept: ".pdf"
                                    }, {
                                        append: _withCtx(() => [
                                            _createVNode(_component_q_icon, { name: "file_upload" })
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, { align: "right" }, {
                            default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_q_btn, {
                                    flat: "",
                                    label: "閉じる",
                                    color: "grey-7",
                                    onClick: _cache[34] || (_cache[34] = ($event) => (_ctx.tmpFile = []))
                                }, null, 512), [
                                    [_directive_close_popup]
                                ]),
                                _withDirectives(_createVNode(_component_q_btn, {
                                    flat: "",
                                    label: "確定",
                                    color: "green-7",
                                    disable: _ctx.tmpFile.length === 0 || _ctx.props.row.fileList.filter(x => x.fileKb === 0 && x.delFlg === false).length === 1 || _ctx.errorFlg,
                                    onClick: _cache[35] || (_cache[35] = ($event) => (_ctx.uploadFile(_ctx.tmpFile, _ctx.props.row, 0)))
                                }, null, 8, ["disable"]), [
                                    [_directive_close_popup]
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_q_dialog, {
            modelValue: _ctx.dialogOpenOther,
            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((_ctx.dialogOpenOther) = $event)),
            persistent: ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "q-gutter-md" }, {
                            default: _withCtx(() => [
                                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "q-px-md" }, [
                                    _createElementVNode("div", {
                                        class: "text-h5",
                                        style: { "font-weight": "bold" }
                                    }, "その他（ファイル）"),
                                    _createElementVNode("ul", null, [
                                        _createElementVNode("li", { class: "text-subtitle2" }, "一度にアップロードできるファイルは、最大10件です。"),
                                        _createElementVNode("li", { class: "text-subtitle2" }, "アップロード可能なファイル形式は、JPG、JPEG、PNG、PDFです。")
                                    ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_q_file, {
                                        modelValue: _ctx.tmpFile,
                                        "onUpdate:modelValue": [
                                            _cache[37] || (_cache[37] = ($event) => ((_ctx.tmpFile) = $event)),
                                            _cache[38] || (_cache[38] = ($event) => (_ctx.onFilePicked(_ctx.tmpFile, _ctx.props.row)))
                                        ],
                                        outlined: "",
                                        dense: "",
                                        "use-chips": "",
                                        multiple: "",
                                        label: "ファイル選択",
                                        accept: ".jpg, .jpeg, .png, .pdf"
                                    }, {
                                        append: _withCtx(() => [
                                            _createVNode(_component_q_icon, { name: "file_upload" })
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, { align: "right" }, {
                            default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_q_btn, {
                                    flat: "",
                                    label: "閉じる",
                                    color: "grey-7",
                                    onClick: _cache[39] || (_cache[39] = ($event) => (_ctx.tmpFile = []))
                                }, null, 512), [
                                    [_directive_close_popup]
                                ]),
                                _withDirectives(_createVNode(_component_q_btn, {
                                    flat: "",
                                    label: "確定",
                                    color: "green-7",
                                    disable: _ctx.tmpFile.length === 0 || _ctx.props.row.fileList.filter(x => x.fileKb === 1 && x.delFlg === false).length + _ctx.tmpFile.length > 10 || _ctx.errorFlg,
                                    onClick: _cache[40] || (_cache[40] = ($event) => (_ctx.uploadFile(_ctx.tmpFile, _ctx.props.row, 1)))
                                }, null, 8, ["disable"]), [
                                    [_directive_close_popup]
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["modelValue"])
    ], 64));
}
